module.exports = __webpack_public_path__ + "static/media/3.e50f00d2.jpg";